// Simplified block diagrams, one per project plus the front-page stack.
// A diagram is a left-to-right chain of nodes. edges[i] labels the link
// from nodes[i] to nodes[i + 1]. Consecutive nodes that share a `zone`
// are drawn inside one dashed boundary. A node with `parts` is drawn as
// stacked sub-blocks. Everything here restates the resume.

export const stackDiagram = {
  caption: 'Where I work, from client to deploy',
  nodes: [
    {
      label: 'Clients',
      parts: [
        { label: 'Web', sub: 'React, Next.js, TypeScript' },
        { label: 'iOS', sub: 'SwiftUI, UIKit, Core Data' }
      ]
    },
    { label: 'Services', sub: 'FastAPI, Node.js, Express, Convex' },
    {
      label: 'State',
      parts: [
        { label: 'Stores', sub: 'PostgreSQL, MongoDB, Firestore' },
        { label: 'Fan-out', sub: 'Redis pub/sub' }
      ]
    },
    { label: 'Delivery', sub: 'Docker, Nginx, AWS, GitHub Actions' }
  ],
  edges: ['REST, WebSockets, MQTT', 'queries, events', 'CI/CD']
};

export const projectDiagrams = {
  converge: {
    caption: 'Converge: clients sync through stateless FastAPI nodes',
    nodes: [
      { label: 'Browser client', sub: 'React, TypeScript, local RGA replica' },
      { label: 'Nginx', sub: 'reverse proxy', zone: 'Docker on AWS' },
      { label: 'FastAPI x N', sub: 'integrates ops per document', zone: 'Docker on AWS' },
      {
        label: 'State',
        zone: 'Docker on AWS',
        parts: [
          { label: 'Redis', sub: 'pub/sub across instances' },
          { label: 'PostgreSQL', sub: 'persistence' }
        ]
      }
    ],
    edges: ['ops over WebSocket', 'proxied socket', 'fan-out, persist']
  },
  'sentiment-aura': {
    caption: 'Sentiment Aura: results return to the browser over the same socket',
    nodes: [
      {
        label: 'Browser',
        parts: [
          { label: 'AudioWorklet', sub: '16 kHz PCM from the mic' },
          { label: 'react-p5', sub: 'Perlin-noise flow field' }
        ]
      },
      { label: 'FastAPI proxy', sub: 'brokers Deepgram auth' },
      { label: 'Deepgram', sub: 'streaming speech-to-text' },
      { label: 'Claude API', sub: 'sentiment, intensity, keywords' }
    ],
    edges: ['PCM over WebSocket', 'audio stream', 'final segments']
  },
  preppal: {
    caption: 'PrepPal: generation and storage stay on the phone',
    nodes: [
      { label: 'SwiftUI views', sub: 'meal plans, grocery lists', zone: 'On device' },
      { label: 'View models', sub: 'MVVM', zone: 'On device' },
      {
        label: 'Local',
        zone: 'On device',
        parts: [
          { label: 'Ollama LLM', sub: 'offline plan generation' },
          { label: 'Core Data', sub: 'offline-first cache' }
        ]
      },
      { label: 'Firebase', sub: 'Auth, Firestore, shared lists' }
    ],
    edges: ['bindings', 'generate, persist', 'multi-device sync']
  },
  tonesafe: {
    caption: 'ToneSafe: the whole pipeline runs on device',
    nodes: [
      { label: 'Message draft', sub: 'SwiftUI composer', zone: 'On device, no text leaves the phone' },
      { label: 'Core ML', sub: 'text classifier', zone: 'On device, no text leaves the phone' },
      { label: 'Tone scores', sub: 'per category', zone: 'On device, no text leaves the phone' },
      { label: 'Feedback', sub: 'shown before send', zone: 'On device, no text leaves the phone' }
    ],
    edges: ['text', 'scores', 'analysis']
  }
};
